module.exports={
	"Form": "OrganizationEditManifest",
	"Scope": "Organization-Edit",
	"Descriptors":
	{
		"OrganizationDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "OrgEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "OrgEditIdentity",
				"Group": "OrgEditIdentity"
			}
		},
		"OrganizationDetails.GUIDOrganization":
		{
			"Name": "GUID",
			"Hash": "OrgEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "OrgEditIdentity",
				"Group": "OrgEditIdentity"
			}
		},
		"OrganizationDetails.Name":
		{
			"Name": "Organization Name",
			"Hash": "OrgEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "OrgEditIdentity",
				"Group": "OrgEditIdentity"
			}
		},
		"OrganizationDetails.Type":
		{
			"Name": "Type",
			"Hash": "OrgEdit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.VendorCode":
		{
			"Name": "Vendor Code",
			"Hash": "OrgEdit-VendorCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.ExternalOrganizationID":
		{
			"Name": "External Organization ID",
			"Hash": "OrgEdit-ExternalOrgID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.Approved":
		{
			"Name": "Approved",
			"Hash": "OrgEdit-Approved",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.DisadvantagedBusiness":
		{
			"Name": "Disadvantaged Business",
			"Hash": "OrgEdit-DisadvantagedBusiness",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.Email":
		{
			"Name": "Email",
			"Hash": "OrgEdit-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgEditContact",
				"Group": "OrgEditContact"
			}
		},
		"OrganizationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "OrgEdit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgEditContact",
				"Group": "OrgEditContact"
			}
		},
		"OrganizationDetails.Address":
		{
			"Name": "Address",
			"Hash": "OrgEdit-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 12,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		},
		"OrganizationDetails.City":
		{
			"Name": "City",
			"Hash": "OrgEdit-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		},
		"OrganizationDetails.State":
		{
			"Name": "State",
			"Hash": "OrgEdit-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		},
		"OrganizationDetails.Zip":
		{
			"Name": "ZIP Code",
			"Hash": "OrgEdit-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "OrgEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "OrgEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "OrgEditDetails",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "OrgEditDetails",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "OrgEditContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "OrgEditContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "OrgEditAddress",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "OrgEditAddress",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
